import { MouseEvent } from 'react';

export const applySectionMargin = (key: number, sections: any) => {
  if (key === 0) return 'py-48 sm:py-64 md:py-104';
  // If current section is colored and next section is colored
  // Don't add margin (because sections probably have paddings)
  if (sections[key] && sections[key + 1]) return;
  // Otherwise, add a margin bottom
  return 'pb-48 sm:pb-64 md:pb-104';
};

export interface DatoButtonProps {
  ctaButton: any;
  params?: string;
  isClientLink?: boolean;
  isBlogArticle?: boolean;
  trackingEvent?: string;
  isTitleResponsive?: boolean;
  as?: string;
  onClick?: (event?: MouseEvent) => void;
  screenSize?: string;
}

export const getCurrencyObject = (
  locale: 'fr' | 'en' | 'es',
): { symbol: '£' | '€'; code: 'GBP' | 'EUR' } => {
  switch (locale) {
    case 'en':
      return {
        symbol: '£',
        code: 'GBP',
      };
    default:
      return {
        symbol: '€',
        code: 'EUR',
      };
  }
};

export type ClassName = string | boolean | undefined;

export const applyStyles = (isDark = false, color: any = 'blue') => {
  let result = '';

  if (isDark) result += 'text-neutral-1 ';
  if (color === 'blue' && isDark) result += 'bg-blue-301 ';
  if (color === 'blue' && !isDark) result += 'bg-blue-51 text-blue-301 ';
  if (color === 'coral' && isDark) result += 'bg-coral-301 ';
  if (color === 'coral' && !isDark) result += 'bg-coral-51 text-coral-301 ';
  if (color === 'azur' && isDark) result += 'bg-azur-301 ';
  if (color === 'azur' && !isDark) result += 'bg-azur-51 text-azur-301 ';
  if (color === 'yellow' && isDark) result += 'bg-yellow-301 ';
  if (color === 'yellow' && !isDark) result += 'bg-yellow-51 text-yellow-301 ';
  if (color === 'purple' && isDark) result += 'bg-purple-301 ';
  if (color === 'purple' && !isDark) result += 'bg-purple-51 text-purple-301 ';
  if (color === 'mint' && isDark) result += 'bg-mint-301 ';
  if (color === 'mint' && !isDark) result += 'bg-mint-51 text-mint-301 ';
  if (color === 'none' && isDark) result += '';
  if (color === 'none' && !isDark) result += '';

  return result;
};

export const cardsListTitle: any = {
  fr: 'Découvrir plus de nouveautés',
  es: '',
  en: 'Discover other new features',
};

export const readArticle: any = {
  fr: 'Lire l’article',
  en: 'Read the article',
  es: 'Leer el artículo',
};
